<template>
  <router-view />
</template>

<script>
const urlB64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};
  
export default {
    name: 'App',
    components: {

    },
    data: () => ({

    }),
    created () {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/service-worker.js')
                .then((reg) => {
                    navigator.serviceWorker.ready.then(reg => {
                    });
                }).catch((err) => {
                    console.log("Error registering service worker: ", err);
                });
        }
    },
};
</script>
